export default __webpack_public_path__ + "static/media/bringing.9d2cd914.jpg";